<template>
  <div>
    <div class="et-enterprise-title">
      <div class="et-enterprise-logo fl">
        <img src="http://www.cajay.net/images/logo.png" alt />
      </div>
      <div class="et-enterprise-name fl">
        <h1>
          广州凯捷物流供应链有限公司
        </h1>
        官方网站:<a href="www.cajay.net" target="_black">www.cajay.net</a>
      </div>
      <div class="et-enterprise-info fl">
        <i class="iconfont-small icon-account"></i>
        <span>5-10</span><br />
        <i class="iconfont-mini icon-phone"></i>
        <span>020-31216136</span><br />
        <i class="iconfont icon-location"></i>
        <span>广东省广州市白云区嘉禾街望岗上胜东街46号上胜创意园K栋101</span>
      </div>
      <div class="clear"></div>
    </div>
    <div class="et-enterprise-body">
      <el-tabs v-model="activename">
        <el-tab-pane label="企业信息" name="enterpriseinfo">
          <div class="et-enterprise-label">公司简介</div>
          <div class="et-enterprise-content">
            凯捷物流是一家致力于为跨境电商提供全球物流服务并提供专业运输方案的服务商。
            公司旗下拥有三大类，50余种物流产品和服务，涵盖自营商业专线、FBA头程物流、邮政和快递代理等解决方案；能够满足不同类型和规模跨境电商的物流需求。凯捷物流的核心渠道为直发各国的商业专线，在商业专线领域我们具有行业领先地位。
            我们在全球拥有超过350名专业物流服务人员，在中国大陆地区建立了7个直营网点，并且在英国、法国、德国、意大利，荷兰，日本、美国等国家拥有超过10个集货中转中心，日处理电商订单量超过30万件。
            凯捷物流成立以来，以持续提升运转效率和客户体验为宗旨，专注跨境电商物流服务领域，注重软硬件科技应用，坚持产品和服务创新，不断优化操作流程，降低物流成本，以专业的物流解决方案和优质的服务水准赢得了广大客户的信任及赞誉，为中国跨境电商行业的快速发展起到了积极推动作用。
            凯捷物流将继续秉承持续创新精神，以用户第一客户至上的经营态度，力争成为跨境电商物流行业的领导者。
          </div>
          <div class="et-enterprise-label">联系人</div>
          <div class="et-enterprise-content">
            <table border="0" cellspacing="0" cellpadding="0" class="et-enterprise-contact">
              <tr>
                <td><i class="iconfont icon-account"></i>总经理-焦志强</td>
                <td><i class="iconfont icon-mobile"></i>15999985930</td>
                <td><i class="iconfont icon-wechat"></i>jiao541538056</td>
                <td><i class="iconfont icon-email"></i>15999985930@qq.com</td>
                <td>
                  <a class="qq" target="_blank" v-bind:href="'http://wpa.qq.com/msgrd?v=3&uin=15999985930&site=qq&menu=yes'">
                    <img border="0" src="/static/qq_talk.gif" alt="点击这里给我发消息" title="点击这里给我发消息">
                  </a>
                </td>
              </tr>
              <tr>
                <td><i class="iconfont icon-account"></i>总经理-焦志强</td>
                <td><i class="iconfont icon-mobile"></i>15999985930</td>
                <td><i class="iconfont icon-wechat"></i>jiao541538056</td>
                <td><i class="iconfont icon-email"></i>15999985930@qq.com</td>
                <td>
                  <a class="qq" target="_blank" v-bind:href="'http://wpa.qq.com/msgrd?v=3&uin=15999985930&site=qq&menu=yes'">
                    <img border="0" src="/static/qq_talk.gif" alt="点击这里给我发消息" title="点击这里给我发消息">
                  </a>
                </td>
              </tr>
            </table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="物流产品" name="channel">
          <el-table :data="channellist" class="et-enterprise-channel-list">
            <el-table-column label="渠道信息">
              <template slot-scope="scope">
                <div class="et-enterprise-channelname">
                  <router-link :to="{name:'channel',params:{channelid:scope.row.channelid}}" tag="span">{{scope.row.channelname}}</router-link>
                  <img class="et-enterprise-channel-list-img" src="/static/home/pick-60-32.png" alt /><img class="et-enterprise-channel-list-img" src="/static/home/send-60-32.png" alt /></div>
                <div>{{scope.row.CarriersName}}</div>
                <span v-for="(item,index) in scope.row.ParcelAttributeList" :key="item.value" class="et-enterprise-channel-label">{{index>0?'、':''}}{{item.label}}</span>
                <div class="et-enterprise-channel-label">{{regionmodule.regionEachTrim(scope.row.ShipmentRegion,regionmodule.regions,0)}}出口</div>
              </template>
            </el-table-column>
            <el-table-column label="渠道简介" prop="ChannelSynopsis">
              <template slot-scope="scope">
                <div>渠道种类：{{scope.row.ChannelType}}&nbsp;&nbsp;&nbsp;&nbsp;线路种类：{{scope.row.ChannelLineType}}</div>
                <div>{{scope.row.MaxWeight>0?'限重：'+scope.row.MaxWeight+'KG':''}}&nbsp;&nbsp;{{scope.row.MaxLong>0?'限长:'+scope.row.MaxLong+'cm':''}}&nbsp;&nbsp;{{scope.row.MaxVolume>0?+'限积:'+scope.row.MaxVolume+'m³':''}}</div>
                <div>{{scope.row.ChannelSynopsis}}</div>
                <el-tooltip :content="scope.row.ChannelLinePurposes" placement="top">
                  <span class="et-enterprise-channel-label">派送范围</span>
                </el-tooltip>
                &nbsp;&nbsp;&nbsp;
                <el-tooltip :content="scope.row.ChannelLineShipments" placement="top">
                  <span class="et-enterprise-channel-label">揽收范围</span>
                </el-tooltip>

              </template>
            </el-table-column>
            <el-table-column label="预计时效" width="150px">
              <template slot-scope="scope">
                {{scope.row.EstimatedStartDay}}-{{scope.row.EstimatedEndDay}}天
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120px">
              <template slot-scope="scope">
                <router-link :to="{name:'create_delivery',params:{enterpriseid:'0',channelid:'0'}}">
                  <template>
                    <el-button size="mini" type="primary">下单</el-button>
                  </template>
                </router-link>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="企业网点" name="enterprisebranches">
          <div class="fl" id="etmap"></div>
          <div class="et-branches-table fl">
            <ul>
              <li v-for="(item,index) in brancheslist" :key="index">
                <div>
                  <span class="branches-label" @click="baiduMapLabelClick(item)">{{item.BranchesName}}</span><br />
                  <span class="branches-phone"><i class="iconfont-mini icon-phone"></i>&nbsp;&nbsp;&nbsp;{{item.Phone}}</span><br />
                  <span>{{regionmodule.regionEach(item.BranchesRegion,regionmodule.regions,0)+item.BranchesStreet+item.BranchesAddress}}</span>
                </div>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="资讯/公告" name="notice">
          <table border="0" cellspacing="0" cellpadding="0" class="et-enterprise-notice-list">
            <tr>
              <td rowspan="2" style="width:150px;text-align:center;">2018年12月18日</td>
              <td rowspan="2" style="width:100px;text-align:center;">
                <el-tag type="success">公告</el-tag>
              </td>
              <td class="title">法国“黄马甲”运动蔓延至半个欧洲，近期出口欧洲需关注货物延误</td>
              <td rowspan="2">
                <router-link :to="{name:'notice'}">
                  <el-button size="mini" type="primary">查看详情</el-button>
                </router-link>
              </td>
            </tr>
            <tr>
              <td>
                <div class="content">
                据悉，截至今日法国“黄背心”抗议示威活动已经进入了第6周，近段时间该国有数万名抗议者走上全法国各城市街头，一度与防暴警察发生冲突，严重程度为几十年来罕见。

                目前，法国政府已针对燃油税做出让步，但是与此同时，这项抗议示威活动已蔓延至欧洲多国，抗议热潮烧向全欧洲。

                目前不止法国告急，整个欧洲都笼罩在抗议罢工活动的阴影下。雨果网了解到， “黄背心”运动进入第四个周末时，除了意大利以外，比利时、荷兰、德国等国也有群众响应这场发源自法国的抗议活动，之后“黄背心”示威浪潮蔓延至欧洲多国，整个欧洲大陆都笼罩在对经济下滑、税收增加的不满情绪当中。
                </div>
              </td>

            </tr>
          </table>
          <ul>
            <li> </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="企业评分" name="enterprisescore">
          <div class="et-enterprise-score">
            <div class="score-title">
              <span class="fl">综合评分：</span>
              <span class="score-title-data">{{scoreAvg()}}</span>
            </div>
            <ul class="et-enterprise-score-list fl">
              <li v-for="(item,index) in enterprisescorelist" :key="index" @mouseover="scoreMouseover(item)">
                <span>{{item.scorelabel}}：</span><span class="et-enterprise-score-list-data">{{item.score}}</span>
              </li>
            </ul>
            <table border="0" cellspacing="0" cellpadding="0" class="et-enterprise-score-details fl">
              <tr>
                <td style="width:200px;">
                  <el-rate v-bind="5" v-model="enterprisescoredetails.score" disabled show-score></el-rate>
                </td>
                <td>
                  共{{enterprisescoredetails.total}}人打分
                </td>
              </tr>
              <tr>
                <td>
                  <el-rate v-model="five" disabled show-score class="score-details"></el-rate>
                </td>
                <td>
                  <el-progress :percentage="Number(enterprisescoredetails.five/enterprisescoredetails.total*100).toFixed(2)" color="rgb(247, 186, 42)"></el-progress>
                </td>
              </tr>
              <tr>
                <td>
                  <el-rate v-model="four" disabled show-score class="score-details"></el-rate>
                </td>
                <td>
                  <el-progress :percentage="Number(enterprisescoredetails.four/enterprisescoredetails.total*100).toFixed(2)" color="rgb(247, 186, 42)"></el-progress>
                </td>
              </tr>
              <tr>
                <td>
                  <el-rate v-model="three" disabled show-score class="score-details"></el-rate>
                </td>
                <td>
                  <el-progress :percentage="Number(enterprisescoredetails.three/enterprisescoredetails.total*100).toFixed(2)" color="rgb(247, 186, 42)"></el-progress>
                </td>
              </tr>
              <tr>
                <td>
                  <el-rate v-model="two" disabled show-score class="score-details"></el-rate>
                </td>
                <td>
                  <el-progress :percentage="Number(enterprisescoredetails.two/enterprisescoredetails.total*100).toFixed(2)" color="rgb(247, 186, 42)"></el-progress>
                </td>
              </tr>
              <tr>
                <td>
                  <el-rate v-model="one" disabled show-score class="score-details"></el-rate>
                </td>
                <td>
                  <el-progress :percentage="Number(enterprisescoredetails.one/enterprisescoredetails.total*100).toFixed(2)" color="rgb(247, 186, 42)"></el-progress>
                </td>
              </tr>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activename: 'enterpriseinfo',
      center: { lng: 113.290374, lat: 23.238916 },
      one: 1,
      two: 2,
      three: 3,
      four: 4,
      five: 5,
      enterprisescorelist: [
        {
          score: 4.5,
          scorelabel: '服务评分',
          one: 0,
          two: 2,
          three: 5,
          four: 10,
          five: 25
        },
        {
          score: 4,
          scorelabel: '价格评分',
          one: 6,
          two: 13,
          three: 9,
          four: 15,
          five: 13
        },
        {
          score: 4.3,
          scorelabel: '时效评分',
          one: 4,
          two: 3,
          three: 13,
          four: 20,
          five: 33
        },
        {
          score: 4.8,
          scorelabel: '质量评分',
          one: 1,
          two: 2,
          three: 5,
          four: 10,
          five: 25
        }
      ],
      enterprisescoredetails: {
        score: 0,
        scorelabel: '',
        one: 0,
        two: 0,
        three: 0,
        four: 0,
        five: 0,
        total: 0
      },
      channellist: [
        {
          channelname: '广州小包挂号',
          CarriersName: '中国邮政',
          ShipmentRegion: ['440000', '440100'],
          ParcelAttributeList: [
            { label: '普货', value: '0' },
            { label: '带电', value: '1' }
          ],
          ChannelType: '小包',
          ChannelLineType: '地区线路',
          EstimatedStartDay: 15,
          EstimatedEndDay: 30,
          MaxWeight: 2,
          MaxLong: 0,
          MaxVolume: 0,
          ChannelSynopsis: '当天上网，广州直飞',
          ChannelLinePurposes: '美国、英国、法国、日本、老挝',
          ChannelLineShipments: '广州'
        }
      ],
      brancheslist: [
        {
          BranchesName: '嘉禾营业部',
          BranchesRegion: ['440000', '440100', '440111'],
          BranchesRegionStr: '',
          BranchesStreet: '嘉禾街道',
          BranchesAddress: '上胜东街上胜创意园K栋101',
          Phone: 13152421121,
          baiduMarker: null
        },
        {
          BranchesName: '阳光营业部',
          BranchesRegion: ['440000', '441800', '441802'],
          BranchesRegionStr: '',
          BranchesStreet: '龙塘镇',
          BranchesAddress: '阳光壹佰阿尔勒',
          Phone: 13152421121,
          baiduMarker: null
        },
        {
          BranchesName: '第一国际营业部',
          BranchesRegion: ['440000', '441900', '441902'],
          BranchesRegionStr: '',
          BranchesStreet: '第一国际',
          BranchesAddress: '',
          Phone: 13152421121,
          baiduMarker: null
        }
      ]
    }
  },
  mounted () {
    this.baiduMapInit()
    if (this.enterprisescorelist.length > 0) {
      this.scoreMouseover(this.enterprisescorelist[0])
    }
  },
  methods: {
    baiduMapInit () {
      var map = new BMap.Map("etmap");
      map.centerAndZoom(new BMap.Point(this.center.lng, this.center.lat), 10);

      this.brancheslist.forEach((item, index) => {
        var content = this.regionmodule.regionEachTrim(item.BranchesRegion, this.regionmodule.regions, 0)
        var title = item.BranchesStreet + item.BranchesAddress
        var myGeo = new BMap.Geocoder()
        var self = this
        myGeo.getPoint(title, function (point) {
          if (point) {
            var marker = new BMap.Marker(point)
            map.addOverlay(marker)
            map.enableScrollWheelZoom(true) //允许鼠标缩放地图
            item.baiduMarker = marker
            marker.addEventListener('click', (e) => {
              self.baiduMapLabelClick(item)
            })
            // if (index === 0) {
            //   marker.click()
            // }
          }
        }, content)
      })
      this.baiduMap = map
    },
    baiduMapLabelClick (item) {
      var infoWindow = new BMap.InfoWindow(this.regionmodule.regionEachTrim(item.BranchesRegion, this.regionmodule.regions, 0) + item.BranchesStreet + item.BranchesAddress, { width: 300, height: 100, title: item.BranchesName + '<br /><span style="color:#999999;font-size:12px;">联系电话：' + item.Phone + '</span>', enableMessage: true })
      this.baiduMap.openInfoWindow(infoWindow, item.baiduMarker.point)
      this.baiduMap.setCenter(item.baiduMarker.point)
    },
    scoreAvg () {
      var sumScore = 0
      this.enterprisescorelist.forEach((item, index) => {
        sumScore += item.score
      })
      return sumScore / this.enterprisescorelist.length
    },
    scoreMouseover (item) {
      this.enterprisescoredetails.score = item.score
      this.enterprisescoredetails.one = item.one
      this.enterprisescoredetails.two = item.two
      this.enterprisescoredetails.three = item.three
      this.enterprisescoredetails.four = item.four
      this.enterprisescoredetails.five = item.five
      this.enterprisescoredetails.total = item.one + item.two + item.three + item.four + item.five
    }
  }
}
</script>

<style>
@import "../../css/home/home.css";
@import "../../css/iconfont.css";

.et-enterprise-body {
  width: 1280px;
  margin: 20px auto 20px auto;
  padding: 20px;
  background-color: #ffffff;
  min-height: 450px;
}

.et-enterprise-body .et-enterprise-label {
  font-size: 22px;
  line-height: 30px;
  padding: 20px 0;
}

.et-enterprise-body .et-enterprise-content {
  line-height: 30px;
  font-size: 16px;
}

.et-enterprise-body .et-enterprise-contact {
  width: 100%;
  font-size: 18px;
}

.et-enterprise-body .et-enterprise-channelname {
  font-size: 16px;
  color: rgb(75, 141, 227);
}

.et-enterprise-body .et-enterprise-channel-label {
  font-size: 12px;
  color: #999999;
}

.et-enterprise-body .et-enterprise-channel-list th {
  line-height: 40px;
  color: #ffffff;
  font-size: 16px;
  background-color: #757575;
  padding: 0 5px;
}
.et-enterprise-body
  .et-enterprise-channel-list
  .et-enterprise-channel-list-img {
  width: 30px;
  height: 16px;
  padding-left: 20px;
  vertical-align: middle;
}

.et-enterprise-body #etmap {
  width: 900px;
  height: 100%;
  min-height: 720px;
}

.et-enterprise-body .et-branches-table {
  width: 350px;
  height: 720px;
  overflow: auto;
  border: 1px solid #f2f2f2;
  line-height: 25px;
}
.et-enterprise-body .et-branches-table ul {
  margin: 0;
  padding: 0;
}

.et-enterprise-body .et-branches-table li {
  border-bottom: 1px solid #f2f2f2;
}

.et-enterprise-body .et-branches-table li.active {
  background-color: #dffcff;
}

.et-enterprise-body .et-branches-table li:hover {
  background-color: #dffcff;
}

.et-enterprise-body .et-branches-table div {
  padding: 0 10px;
}

.et-enterprise-body .branches-label {
  color: #1981c8;
  cursor: pointer;
}

.et-enterprise-body .branches-phone {
  color: #999999;
  font-size: 12px;
}

.et-enterprise-body .et-enterprise-notice-list {
  width: 100%;
  line-height: 30px;
}

.et-enterprise-body .et-enterprise-notice-list:hover{
  background-color: #dffcff;
}

.et-enterprise-body .et-enterprise-notice-list .title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 900px;
  font-size: 18px;
  color: #1981c8;
}

.et-enterprise-body .et-enterprise-notice-list .content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 700px;
  color: #999999;
  font-size: 12px;
  background-color: none;
}


</style>



// WEBPACK FOOTER //
// src/components/home/enterprise.vue